// src/store/selectionSlice.js
import { createSlice } from "@reduxjs/toolkit";

const selectionSlice = createSlice({
  name: "selection",
  initialState: {
    gatewayId: null,
    watchId: null,
  },
  reducers: {
    setGatewayId(state, action) {
      state.gatewayId = action.payload;
    },
    setWatchId(state, action) {
      state.watchId = action.payload;
    },
  },
});

export const { setGatewayId, setWatchId } = selectionSlice.actions;
export default selectionSlice.reducer;

/**
 * Optional selectors (if you’re using reselect or want simple filters)
 * e.g. select all koncepts that startWith("esp32-"), etc.
 */
export const selectGatewayKoncepts = (state) =>
  state.koncepts.items.filter((k) => k.id.startsWith("esp32-"));

export const selectWatchKoncepts = (state) =>
  state.koncepts.items.filter((k) => k.id.startsWith("healthmonitor-"));
